<template>
  <div>
  <CRUDList class="mt-10" ref="crudList" toolbarTitle="Tax Roll"
  :canAdd='isSelectedRow' :canEdit="false" :canSave="true"
    :showSelect="false" :enableFixedHeaders="true" :canDelete="true"
    :displayTopPagination="false" :headers="headers" :tabsList="tabsList"
    :baseCrudKey="baseCrudKey"
    :defaultSortBy="defaultSortBy"
    tableWrapperDynamicClassname='elevation-3 mt-n5 ma-3 pt-0 pa-1 taxroll-table-wrapper'
    tableDynamicClassname='taxroll-custom-table' tableDynamicHeight='200'
    @emitSelectedItem="emitSelectedItem"
    @emitDeleteRowItem="deleteDetailRow"
    @emitRowButtonClick="handleFeesButtonClick"
    :selectedItems="selectedItems"
    :disablePagination="true"
    dialogDynamicWidth="30vw"
     @upsertItem="upsertTransaction"
    >
    <template  v-slot:[`editedItem`]="{ }">
        <TaxWarantDetailsEditedItem
         :baseCrudKey="baseCrudKey" />
      </template>
  </CRUDList>
  <CRUDDialog
            ref="crudDialog"
            :baseCrudKey="taxWarrantDetailsConfDialogCrudKey"
            :canSave="true"
            :canApply="false"
            @upsertItem="upsertTransactionFromConfirmPopup"
            dialogDynamicWidth='400'
          >
            <template v-slot:[`editedItem`]="{}">
              <slot name="editedItem">
                <v-container>
                   <div>This tax record has no tax due, do you still wish
                    to add it to the selected Personal Tax Warrant?</div>
                </v-container>
              </slot>
            </template>
          </CRUDDialog>
  <CRUDDialog
            :baseCrudKey="ptwFeesDialogCrudKey"
            :canSave="false"
            :canApply="false"
            :canCancel="true"
            dialogDynamicWidth="30vw"
            :onlyDialogHeaderName="`Fees for Tax Year ${feesRowContext.taxYear || ''} / Tax ID ${feesRowContext.taxId || ''}`"
          >
            <template v-slot:[`editedItem`]="{}">
              <CRUDList
                ref="ptwFeesCrudList"
                :canAdd="true" :canEdit="true" :canDelete="true" :canSave="true"
                :showSelect="false" :displayTopPagination="false" :hideDefaultFooter="true"
                :enableFixedHeaders="true" :headers="feesHeaders"
                :baseCrudKey="ptwFeesListCrudKey"
                :defaultSortBy="feesDefaultSortBy"
                :createNewItem="createNewFeeItem"
                tableWrapperDynamicClassname="taxroll-table-wrapper-two"
                tableDynamicHeight="200"
                dialogDynamicWidth="23vw"
                dialogHeaderName="Fee"
                @upsertItem="upsertPTWFee"
                @emitDeleteRowItem="deletePTWFee"
              >
                <template v-slot:[`editedItem`]="{}">
                  <TaxFeesTableDialog :baseCrudKey="ptwFeesListCrudKey" />
                </template>
              </CRUDList>
            </template>
          </CRUDDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { taxWarrantsDetailsHeader } from './TaxWarrantHeaders.utils';
import { FeesHeaders } from '../TaxInquiry/TaxInquiryUtils/TableHeaders.utils';
import '../../../assets/style.css';
import TaxWarantDetailsEditedItem from './dialog/TaxWarantDetailsEditedItem.vue';
import TaxFeesTableDialog from '../TaxInquiry/Common/TaxFeesTableDialog.vue';
import { makeCriteriaStateNullIfEmptyString, mergeCodeWithName } from '../common-utils/CommonTaxFunctionalities';
import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';
// import { taxIsDelinquent } from '../common-utils/tax-common.util';
import { TaxWarrantsMixin } from './utils/taxWarrants.mixin';
import {
  processWarrantItemForUpsert,
  validateWarrantItemWithTaxInquiry,
  cleanWarrantDetailsForGraphQL,
} from './utils/taxWarrants.util';
import { amountToNumber } from '../../../util/shared/vue-global';
import { toIsoDate } from '../../../util/shared/tmc-global';

export default {
  name: 'TaxWarrantsDetailsList',
  mixins: [TaxWarrantsMixin],
  data() {
    return {
      tabsList: [],
      checkbox: true,
      fromDate: '07/01/2023',
      baseCrudKey: 'taxdetailsWarrantList',
      taxWarrantCrudKey: 'personalTaxWarrants',
      taxWarrantDetailsConfDialogCrudKey: 'taxWarrantDetailsConfDialogCrudKey',
      headers: taxWarrantsDetailsHeader,
      feesHeaders: FeesHeaders,
      ptwFeesListCrudKey: 'ptwFeesList',
      ptwFeesDialogCrudKey: 'ptwFeesDialog',
      feesRowContext: { taxYear: null, taxId: null, taxInquiryTransaction: null },
    };
  },
  components: {
    CRUDList,
    TaxWarantDetailsEditedItem,
    TaxFeesTableDialog,
    CRUDDialog,
  },
  created() {
    // Fee-number dropdown (inside TaxFeesTableDialog) and feeDescription lookups both read
    // off this shared master list - other screens that show fee editing UI (TaxDelinquent,
    // TaxInquiry, taxRollWorkFile) each load it themselves the same way, since it's not
    // fetched globally.
    this.loadTaxFeeMasterTypes({
      criteria: { sortBy: [{ column: 'feeNumber', direction: 'asc' }] },
      baseCrudKey: 'sharedTaxFeeMaster',
      postProcessTrans: (items) => mergeCodeWithName(items, 'feeNumber', 'feeDescription', true),
    });
  },
  computed: {
    // Inherit most computed properties from TaxWarrantsMixin
    // Only add component-specific computed properties
    isSelectedRow() {
      const item = this.item('personalTaxWarrants');
      if (item._id) {
        return true;
      }
      return false;
    },
    feesDefaultSortBy() {
      return [
        {
          column: 'effectiveDate',
          direction: 'desc',
        },
      ];
    },
    ...mapState({
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData,
    }),
  },
  methods: {
    ...mapActions('tax/taxFee', ['loadTaxRollFeesTable', 'upsertTaxFees', 'deleteTaxFees']),
    ...mapActions('shared/taxFeeMaster', ['loadTaxFeeMasterTypes']),
    // Inherit most methods from TaxWarrantsMixin
    // Only add component-specific methods
    resetCriteria() {
      window.location.reload();
    },

    // Override the mixin's handleLoadWarrantList for this component's specific needs
    async handleLoadWarrantList() {
      let criteriaState = this.criteria(this.taxWarrantCrudKey);

      const returnCriteria = makeCriteriaStateNullIfEmptyString(criteriaState);
      criteriaState = { ...returnCriteria };
      const criteria = {
        ...criteriaState,
      };
      await this.loadTaxWarrants({
        criteria,
        baseCrudKey: this.taxWarrantCrudKey,
        postProcessTrans: this.postProcessWarrantData,
      });
      // loadTaxWarrants only refreshes the taxWarrantCrudKey items list - the separately
      // tracked selected `item` (set once, when the warrant row was clicked) is left stale.
      // Re-sync it from the freshly reloaded list before reading its taxWarrantDetails, or a
      // fee edit/delete wouldn't show updated totals here until the warrant was reselected.
      const previouslySelectedItem = this.item(this.taxWarrantCrudKey);
      const refreshedList = this.items(this.taxWarrantCrudKey) || [];
      const selectedItem = refreshedList.find((w) => w._id === previouslySelectedItem._id)
        || previouslySelectedItem;
      this.setItem([this.taxWarrantCrudKey, selectedItem]);
      this.$nextTick(() => {
        this.setItems([this.baseCrudKey, selectedItem.taxWarrantDetails || []]);
      });
    },
    // Override the mixin's upsertTransaction for this component's specific needs
    async upsertTransaction(item) {
      const context = {
        loadTaxInquires: this.loadTaxInquires,
      };

      // Enhanced validation that automatically fetches tax inquiry data if needed
      const warrantPenaltyDate = (this.item(this.taxWarrantCrudKey) || {}).penaltyDate;
      const validation = await validateWarrantItemWithTaxInquiry(
        item,
        context,
        this.taxSettingItem,
        warrantPenaltyDate,
      );
      if (!validation.isValid) {
        this.flashWarn(validation.message);
        return;
      }

      // If data was fetched, show success message and update the store
      if (validation.dataFetched) {
        this.custumColrFlashMsg({ msg: 'Tax inquiry data loaded successfully' });

        // Update the taxWarrantCrudKey item in store with the fetched data
        const currentWarrantItem = this.item(this.taxWarrantCrudKey);
        const updatedWarrantItem = {
          ...currentWarrantItem,
          ...validation.fetchedData, // Use the returned fetched data
        };
        this.setItem([this.taxWarrantCrudKey, updatedWarrantItem]);
      }

      // Now get the updated taxWarrantItem from store
      const taxWarrantItem = this.item(this.taxWarrantCrudKey);
      const taxWarrantDetails = [
        item,
        ...taxWarrantItem.taxWarrantDetails,
      ];

      // Process items - add to taxWarrantDetails array
      taxWarrantItem.taxWarrantDetails = taxWarrantDetails;
      let updatedItem = { ...taxWarrantItem };

      // Clean taxWarrantDetails array - remove invalid fields for GraphQL
      if (updatedItem.taxWarrantDetails) {
        updatedItem.taxWarrantDetails = cleanWarrantDetailsForGraphQL(
          updatedItem.taxWarrantDetails,
        );
      }

      // Use utility function to process the main warrant item
      updatedItem = processWarrantItemForUpsert(updatedItem);

      // Handle tax inquiry transaction (specific to this component's data structure)
      if (updatedItem.taxInquiryTransaction && typeof updatedItem.taxInquiryTransaction === 'object') {
        updatedItem.taxInquiryTransaction = updatedItem.taxInquiryTransaction._id;
      }

      // upsertWarrants now rethrows on failure (it used to swallow); guard here so a
      // failed save stops cleanly instead of leaking an unhandled rejection and
      // skipping the reload/detail-sync below.
      try {
        await this.upsertWarrants({ item: updatedItem, baseCrudKey: this.taxWarrantCrudKey });
      } catch (error) {
        return;
      }

      // Reload tax warrants to get updated data
      await this.handleLoadWarrantList();

      // Find and set the same selected record's taxWarrantDetails
      const updatedSelectedItem = this.item(this.taxWarrantCrudKey);
      if (updatedSelectedItem && updatedSelectedItem.taxWarrantDetails) {
        const taxInqCrudKey = 'taxdetailsWarrantList';
        this.setItems([taxInqCrudKey, updatedSelectedItem.taxWarrantDetails]);
      }
    },

    // Component-specific method for confirmation popup upsert
    async upsertTransactionFromConfirmPopup() {
      const taxWarrantItems = this.item(this.taxWarrantCrudKey);
      let updatedItem = { ...taxWarrantItems };

      // Clean taxWarrantDetails array - remove invalid fields for GraphQL
      if (updatedItem.taxWarrantDetails) {
        updatedItem.taxWarrantDetails = cleanWarrantDetailsForGraphQL(
          updatedItem.taxWarrantDetails,
        );
      }

      // Use utility function to process the warrant item,
      // but preserve some keys for this specific case
      const preservedKeys = ['address1', 'address2', 'address3', 'address4'];
      const preservedData = {};
      preservedKeys.forEach((key) => {
        if (updatedItem[key]) {
          preservedData[key] = updatedItem[key];
        }
      });

      // Process using utility function
      updatedItem = processWarrantItemForUpsert(updatedItem);

      // Restore preserved data
      Object.assign(updatedItem, preservedData);

      // Remove specific keys for confirmation popup case
      const additionalKeysToRemove = ['name1', 'name2', 'city'];
      additionalKeysToRemove.forEach((key) => {
        delete updatedItem[key];
      });

      // Handle tax inquiry transaction
      if (updatedItem.taxInquiryTransaction && typeof updatedItem.taxInquiryTransaction === 'object') {
        updatedItem.taxInquiryTransaction = updatedItem.taxInquiryTransaction._id;
      }

      // Use mixin's upsertWarrants method. It now rethrows on failure (it used to
      // swallow) - catch here so a failed save just stops instead of leaking an
      // unhandled rejection out of this dialog-confirm handler.
      try {
        await this.upsertWarrants({
          item: updatedItem,
          baseCrudKey: this.taxWarrantCrudKey,
        });
      } catch (error) {
        // upsertWarrants already flashed the error; nothing else to do here.
      }
    },

    // Trashcan icon on a detail row - remove that single tax year from the warrant.
    // The mutation itself recomputes the warrant's rollup totals server-side, so the
    // returned warrant can just be stored as-is.
    async deleteDetailRow(item) {
      const warrantItem = this.item(this.taxWarrantCrudKey);
      const updatedWarrant = await this.deleteTaxWarrantDetailRow({
        deleteInfo: { _id: warrantItem._id, deleteRowId: item._id },
      });
      if (updatedWarrant) {
        this.setItem([this.taxWarrantCrudKey, updatedWarrant]);
        this.setItems([this.baseCrudKey, updatedWarrant.taxWarrantDetails || []]);
      }
    },

    // "Fees" button on a detail row - open the fee list scoped to that row's tax year/tax
    // ID. The warrant detail line doesn't carry the linked tax record's own _id (only
    // taxYear/taxId), so it's resolved fresh here the same way TaxWarantDetailsEditedItem
    // does for the add-record flow - it's needed so upsertPTWFee can keep the tax record's
    // own totalFee in sync (upsertTaxFeesHelper filters by it, not by taxYear/taxId).
    async handleFeesButtonClick(item) {
      const criteria = { taxYear: item.taxYear, taxId: item.taxId };
      const inquiryData = await this.loadTaxInquires({
        criteria, baseCrudKey: 'ptwFeesTaxInquiryLookup',
      });
      const taxInquiryTransaction = (inquiryData && inquiryData[0] && inquiryData[0]._id) || null;
      this.feesRowContext = { taxYear: item.taxYear, taxId: item.taxId, taxInquiryTransaction };
      await this.loadTaxRollFeesTable({ criteria, baseCrudKey: this.ptwFeesListCrudKey });
      this.setIsVisible([this.ptwFeesDialogCrudKey, true]);
    },

    // Pre-seeds a brand-new fee row with the tax year/tax ID it's being added under -
    // mirrors TaxRollFeesTable's handleFeeNewItem.
    createNewFeeItem() {
      return { taxYear: this.feesRowContext.taxYear, taxId: this.feesRowContext.taxId };
    },

    async upsertPTWFee(val) {
      const feeNumber = val.feeNumber ? val.feeNumber : null;
      const filteredTaxMasterList = (this.taxFeeMasterData || [])
        .filter((ft) => ft.feeNumber === feeNumber);
      const feeDescription = filteredTaxMasterList.length > 0
        ? filteredTaxMasterList[0].feeDescription : null;
      const item = {
        taxYear: this.feesRowContext.taxYear,
        taxId: this.feesRowContext.taxId,
        effectiveDate: val.effectiveDate ? toIsoDate(val.effectiveDate) : null,
        feeNumber,
        feeAmount: amountToNumber(val.feeAmount),
        feeDescription,
        taxInquiryTransaction: this.feesRowContext.taxInquiryTransaction,
      };
      if (val._id) item._id = val._id;
      await this.upsertTaxFees({ item, baseCrudKey: this.ptwFeesListCrudKey });
      // The fee edit recomputes this tax year's totalFee/totalDueWithFeesPenalty on every
      // warrant it appears on (syncTaxWarrantDetailsForFeeChange) - reload so the grid and
      // the selected warrant's rollup totals pick that up.
      await this.handleLoadWarrantList();
    },

    async deletePTWFee(item) {
      if (!window.confirm('Are you sure you want to delete this fee?')) return;
      await this.deleteTaxFees({ item, baseCrudKey: this.ptwFeesListCrudKey });
      await this.handleLoadWarrantList();
    },

  },
};
</script>

<style scoped>
.label {
  font-size: 0.85rem;
}
</style>
